export default __webpack_public_path__ + "static/media/aboutsection.64e530bf.jpg";